<template>

  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  > 

    <component
      :is="layout"
      v-if="$route.name !== null"
      :class="(isOutOfDate) ? 'update' : ''"
    >
      <router-view />
    </component>

  </div>

</template>

<script>
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import axios from 'axios'
import {
  BButton,
} from 'bootstrap-vue'

import { useWindowSize, useCssVar,  useIdle, useTimestamp} from '@vueuse/core'



const {
  url, port, auth, websocket,
} = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

import store from '@/store'
import router from './router'


const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    
    BButton,

  },
  data() {
    return {
      appVer: 0,
      isOutOfDate: false,
      ws_connected:true,
   
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    isIdle() {
			return this.$store.state.idleVue.isIdle;
		},
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },

  watch: {
    $route() {
  
    
     this.getUser();
     if(this.$route.name != 'Viewers'){
    
        localStorage.setItem('tab_id',0)
     
     }
      
      
      // this.getVersion()
    },
    layout() {
      this.getUser()
    },
  },

   

  created() {
     this.$root.$refs.apps = this;

    this.getUser()
     this.websocket_connection()
     

   
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')
    document.body.classList.remove('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
  ready() {
    window.addEventListener('beforeunload', this.leaving);
},
  methods: {
   
    beforeunload()
    {
      this.connection.close()
    },
    ping() {
   
      if (this.connection !== null) {
        console.log("SEN DATA", store.state.user.userdata.name)
     
        const task = {
     
          task: 'webtool_ping',tab_id: 0, project: this.$route.params.id ?? 0, sessionToken: localStorage.getItem('sessionToken'), route: this.$route.name, username: store.state.user.userdata.name, user_id: store.state.user.userdata.id ?? 0
        }
        console.log("I SEND" , task)
        this.connection.send(JSON.stringify(task))
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (dismissCountDown === 0) {
        this.wsAlert = false
        if(this.connection == null){this.websocket_connection()}
        
      }
    },
    

    websocket_connection() {
      this.connection = new WebSocket(websocket)
      console.log("Connection here is", this.connection)
      //this.getUser()
      this.connection.onmessage = event => {
        const json = JSON.parse(event.data)
        //console.log("json", json)
        
        if(json.task == 'load_image'){
         // this.$root.$refs.viewer.load_viewer_image(json.image, json.task_id, json.data)
        }
        if(json.task == 'load_preview'){
          try{
          this.$root.$refs.preview.set_preview(json.image)
          }catch(e){}
        }
         if(json.task == 'generated'){
          try{
            var data = localStorage.getItem('new_tab')
            localStorage.setItem('new_tab',0)
            if(data != 1){
         
               this.$root.$refs.viewer.getdata()
              // location.reload()
              
            }else{
                location.reload()
            }
          }catch{   this.$root.$refs.viewer.getdata()}
       
        }
        // if (json.task == 'server_resources')
        // {
        //   this.$root.$refs.processing.prueba_maite(json.data,json.id)
        // }
        // if(json.task == 'server_data')
        // {
        //   this.$root.$refs.processing.getServerStatus(json.data,json.id)
        // }
        if (json.action === 'connection') {
          this.key = json.key
            ///HERE!!
        } else {
          this.message = event.data
        }
      }
      this.connection.onopen = () => {
        this.getUser()
     
        this.wsAlert = false
      }
      this.connection.onerror = () => {
        this.websocket_connection()
        this.wsAlert = true
        this.dismissCountDown = this.dismissSecs
      }
      this.connection.onclose = () => {
       this.websocket_connection()
        this.wsAlert = true
        this.dismissCountDown = this.dismissSecs
      }
    },
    getVersion() {
      this.appVer = $themeConfig.app.appVer
      const { url, port, auth } = store.state.appConfig.api
      const headers = {
        authentication: auth,
        'Content-Type': 'application/json',
      }
      axios.get(`${url}:${port}/config`, { headers })
        .then(response => {
          console.log(response)
          if (response.data.config !== undefined) {
            const version = response.data.config.version * 1
            this.isOutOfDate = (version > this.appVer)
          }
        })
    },
    reloadPage() {
      console.log('reload')
      window.location.reload()
      this.getUser();

    },
      ping_tab(tabId,project_id){
    
        return
       try{
      if (this.connection !== null) {
        const task = {
     
          task: 'webtool_ping',tab_id: tabId, project: project_id, sessionToken: localStorage.getItem('sessionToken'), route: 'Viewer', username: store.state.user.userdata.name, user_id: store.state.user.userdata.id ?? 0
        }
      
        this.connection.send(JSON.stringify(task))
    }}
    catch{}
    },
    
    async getUser() {
      return
      try{
        const { url, port, auth } = store.state.appConfig.api
        const headers = {
          authentication: auth,
          'Content-Type': 'application/json',
        }
        const route_names =  ['Home','Projects','Project','Image Processing','Downstream Analysis','Experimental Design','Users','Login']
        const token = localStorage.getItem('sessionToken')
        await axios.get(`${url}:${port}/user/${token}`, { headers })
          .then(response => {
            store.commit('userdata', response.data.userdata)
            store.commit('token', response.data.userdata.token)
          
            if(route_names.includes(this.$route.name)){  localStorage.setItem('new_in_viewers',0) }
            
            localStorage.setItem('actual_user_id', response.data.userdata.id)
            this.ping()
            
          })
      }catch{}
      
        
      
    },
  },
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap');

.menu-title{
  font-family: "Noto Sans" !important;
  text-transform: uppercase;
}
.update #topBar{
margin-top: 50px;
}
.update {
  margin-top: 50px;
}
.update-warning{
  background:rgb(234, 84, 85); position: absolute; width: 100%; height: 50px; z-index: 100000; top: 0; padding: 10px; color: #000; font-weight:bold;
  text-align: center;
}
html, body, #app {
  background-color: white !important;
}

</style>
